<template>

    <transition name="fade">
        <div class="absolute inset-0 flex items-center lg:rounded-l-xl justify-center bg-black/20 z-50 ">
            <div
                class="bg-white  rounded-xl shadow-lg text-center w-4/5 h-2/3 flex  flex-col  justify-center items-center animate-shake">
                <div class="h-1/4 lg:h-2/5 flex flex-col justify-end items-center ">
                    <!-- <div
                            class="w-12 h-12 border-4 border-[#f01e6b] border-t-transparent rounded-full animate-spin ">
                        </div> -->
                    <div class="text-red-500 text-4xl ">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-square-x-icon lucide-square-x w-1/5 mx-auto  ">
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="m15 9-6 6" />
                            <path d="m9 9 6 6" />
                        </svg>
                    </div>
                </div>
                <div class="h-3/4 lg:h-3/5 w-full p-5 flex flex-col items-center justify-between">
                    <div>
                        <div class="text-sm text-center  mb-2">{{ $t('transactionAccountNotFound') }} </div>
                        <div class="px-3 py-2 rounded-lg bg-slate-200 shadow  text-gray-800  font-medium">{{
                            props.phoneNumber }}</div>

                    </div>
                    <div class="w-full ">
                        <div @click="closeModal"
                            class=" py-2 rounded-lg bg-red-400 shadow  text-sm text-white  font-medium w-1/2 mx-auto hover:cursor-pointer ">
                            {{$t('close')}}</div>

                    </div>
                </div>

            </div>
        </div>

    </transition>
</template>


<script setup>
import { defineProps, defineEmits } from 'vue';


const props = defineProps({
    modalMessage: String,
    phoneNumber: String
});


const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
}

</script>